<template>
  <div class="visit-extend-list">
    <ListingTemplate>

      <template v-slot:body>

        <ListingHeader>
           <template v-slot:content>
                <v-flex class="d-flex justify-flex-end align-center">

                <v-btn
                    color="cyan"
                    class="white--text custom-refresh-btn"
                    :loading="dataLoading"
                    @click="getRows"
                >
                    <v-icon left>mdi-reload</v-icon>
                   
                </v-btn>

                </v-flex>
            </template>
        </ListingHeader>

        <!-- Table -->
        <ListingTable
          :dataLoading="dataLoading"
          :rowData="rowData"
          :columnCount="6"
        >
          <template v-slot:thead>
            <thead>
              <tr>
                <th class="simple-table-th">Visit #</th>
                <th class="simple-table-th">Technician</th>
                <th class="simple-table-th">Remarks</th>
                <th class="simple-table-th">Status</th>
                <th class="simple-table-th">Approved By</th>
                <th class="simple-table-th">Action</th>
              </tr>
            </thead>
          </template>

          <template v-slot:tbody>
            <tbody>
              <tr v-for="row in rowData" :key="row.id">

                <td>
                <Barcode
                      :barcode="row.visit?.barcode"
                      :id="row.id"
                  ></Barcode>
                </td>

                <td>
                  <b>{{ row.technician?.display_name}}</b>
                </td>

                <td>
                  {{ row.remarks || '-' }}
                </td>

                <td>
                  <v-chip small :color="getStatusColor(row.status)" dark>
                    {{ getStatusText(row.status) }}
                  </v-chip>
                </td>

                <td>
                  {{ row.approved_by?.display_name || '-' }}
                </td>

                <td>
                  <template v-if="row.status == '1'">

                    <v-btn
                      class="custom-bold-button white--text"
                      small
                      color="green"
                      @click="updateStatus(row.id, 'accept')">
                        Accept
                    </v-btn>

                    <v-btn
                      style="margin-left:10px;"
                      small
                      class="custom-bold-button white--text"
                      color="red"
                      @click="updateStatus(row.id, 'reject')">
                      Reject
                      </v-btn>

                  </template>
                      <em v-else class="text-muted">--</em>
                  
                </td>

              </tr>

              <tr v-if="!dataLoading && rowData.length === 0">
                 <td :colspan="9">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  Sorry! No Extend Request(s) Found.
                </p>
              </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>

        <!-- Footer -->
        <ListingFooter
           :dataLoading="dataLoading"
          :currentPage="current_page"
          :totalPages="total_pages"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="total_rows"
        />

      </template>
    </ListingTemplate>

  </div>
</template>

<script>
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import Barcode from "@/view/pages/partials/Barcode.vue";
import {PATCH,QUERY } from "@/core/services/store/request.module";

export default {
  name: "visit-extend-list",

  components: {
    ListingTemplate,
    ListingTable,
    ListingHeader,
    ListingFooter,
    Barcode
  },

   props: {

    visitId: {
      type: Number,
      default: 0,
    },

    detail: {
      required: true,
      type: Object,
      default() {
        return new Object();
      },
    },

    visit: {
      type: Object,
      default() {
        return new Object();
      },
    },
    
  },

  data() {
    return {
      rowData: [],
      dataLoading: false,
      per_page: 10,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      
    };
  },

  methods: {

    getRows() {


      this.dataLoading = true;

      this.$store.dispatch(QUERY, {
        url: "visit-extend",
         data: {
            visit : this.visitId,  
            per_page: this.per_page,
            current_page: this.current_page,

          },
      })
      .then(({ data }) => {

        this.offset = data.offset;
        this.rowData = data.rows;
        this.total_pages = Math.ceil(data.total_rows / data.per_page);
        this.current_page = data.current_page;
        this.total_rows = data.total_rows;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    },

    updateStatus(id, status) {

      this.$store.dispatch(PATCH, {

        url: `visit-extend/${id}/status`,
        data: { 
          status 
        },
        }).then(() => {

          this.getRows();

        });
    },

    getStatusText(status) {
      switch (status) {
        case "1": return "Pending";
        case "2": return "Accepted";
        case "3": return "Rejected";
        default: return "-";
      }
    },

    getStatusColor(status) {
      switch (status) {
        case "1": return "orange";
        case "2": return "green";
        case "3": return "red";
        default: return "grey";
      }
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },

  mounted() {

    this.getRows();
    PaginationEventBus.$on("update:pagination", (param) => {
        this.current_page = param;
        this.getRows();
    });

  },

   computed: {

    showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false
        ? this.offset + 1
        : 0;
    },

    showingTo() {
      return this.offset + (this.rowData ? this.rowData.length : 0);
    },
  },




};
</script>